import { useLocation, useNavigate } from "react-router-dom";

const FILTER_DEFAULTS = {
  page: 0,
  size: 20,
};

export function useQueryParams(defaults = {}) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = Object.fromEntries(new URLSearchParams(location.search));

  // Read window.location fresh on every write so consecutive sync calls
  // (e.g. setSearchParams(...) followed by adjustFilter(...)) compose
  // correctly. history.replaceState updates window.location synchronously;
  // useLocation()'s value is only refreshed on the next render.
  function writeQuery(searchParams) {
    const query = searchParams.toString();
    const path = window.location.pathname;
    navigate(query ? `${path}?${query}` : path, { replace: true });
  }

  function setSearchParams(filters) {
    const next = new URLSearchParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value !== null && value !== undefined && value?.trim() !== "") {
        next.set(key, value);
      }
    }
    writeQuery(next);
  }

  function adjustFilter(key, value) {
    const current = new URLSearchParams(window.location.search);
    const defaultValue = FILTER_DEFAULTS[key];

    if (value === null || value === undefined || value === defaultValue) {
      current.delete(key);
    } else {
      current.set(key, value);
    }

    writeQuery(current);
  }

  return { params, setSearchParams, adjustFilter };
}
